import { BackgroundIcon } from "@prismicio/editor-ui"

import type { Release } from "../../app/services/release"

interface ReleaseStatusIndicatorProps {
  release: Release
}

export function ReleaseStatusIndicator(props: ReleaseStatusIndicatorProps) {
  const { release } = props

  return (
    <BackgroundIcon
      name="calendarToday"
      color={getColor(release)}
      size="extraSmall"
      radius={6}
    />
  )
}

function getColor(release: Release) {
  if (release.migration) return "purple"
  if (release.timestamp) return "green"
  return "tomato"
}

export function ReleaseStatusIndicatorSkeleton() {
  return (
    <BackgroundIcon
      name="calendarToday"
      color="grey"
      size="extraSmall"
      radius={6}
    />
  )
}
